module.exports = __webpack_public_path__ + "static/media/MVNZ_web_2_preview.5cd49371.jpg";